// extracted by mini-css-extract-plugin
export var textContainer = "works-module--textContainer--1T6Lq";
export var title = "works-module--title--1Qi8F";
export var list = "works-module--list--17YtB";
export var imageContainer = "works-module--imageContainer--2qHSd";